"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.socketIncomingCommand = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const SocketActionTypes = require("../../actionTypes/socket");
const bim_1 = require("./events/bim");
const report_1 = require("./events/report");
const reliablePartnerStatus_1 = require("./events/reliablePartnerStatus");
const reliablePartnerPdfStatus_1 = require("./events/reliablePartnerPdfStatus");
const automaticFileConversion_1 = require("./events/automaticFileConversion");
const socketIncomingCommand = (action$) => action$.pipe((0, operators_1.filter)((action) => action.type === SocketActionTypes.SOCKET_INCOMING_COMMAND), (0, operators_1.mergeMap)((action) => (0, rxjs_1.merge)((0, bim_1.handleBimEvents)(action), (0, report_1.handleReportEvents)(action), (0, reliablePartnerStatus_1.handleReliablePartnerStatusEvents)(action), (0, reliablePartnerPdfStatus_1.handleReliablePartnerPdfStatusEvents)(action), (0, automaticFileConversion_1.handleAutomaticFileConversionStatusEvents)(action))));
exports.socketIncomingCommand = socketIncomingCommand;
//# sourceMappingURL=index.js.map